import util from '@/utils/util'
import request from '@/utils/request'


export function fetchBillCode(optionName) {
    return request({ url: optionName+'/GetBillCode', method: 'get' });
}

/**
 * 获取采购供应商列表
 */
export function fetchPurchaseSupplier() {
    return request({ url: 'PurchaseSupplier/GetEnabledList', method: 'get' });
}

/**
 * 获取启用的品牌列表
 */
export function fetchPurchaseBrand() {
    return request({ url: 'PurchaseBrand/GetEnabledList', method: 'get' });
}

/**
 * 批量查询采购申请明细最近30天销量及本部门、其他部门可用库存。
 */
export function refreshRequisitionSalesAndStock(companyID, items) {
    return request({
        url: 'PurchaseRequisitionDetail/RefreshSalesAndStock',
        method: 'post',
        data: { companyID, items },
        loading: false
    });
}

/** 只读预览申请审核时的部门金料可用量。 */
export function previewRequisitionGoldAvailability(companyID, departmentID, items) {
    return request({
        url: 'PurchaseRequisitionDetail/PreviewGoldAvailability',
        method: 'post',
        data: { companyID, departmentID, items },
        loading: false
    });
}
